import { D28 } from "./CustomerGroupPerformance/D28";
import { D03 } from "./SalesByChannelActualVSLastYear/D03";

export const DistrictGrowthPerformance = {
  "sections": [
    D28,
    D03
  ]
}